// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.device

import org.multipaz.cbor.DataItem
import org.multipaz.device.Assertion
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.device.AssertionBindingKeys
import org.multipaz.device.AssertionGenericCbor
import org.multipaz.device.AssertionNonce
import org.multipaz.device.AssertionPoPKey
import org.multipaz.device.AssertionRpcAuth

fun Assertion.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "tegS2O43kAnkyJqssBt7QQMty1hOijWJmxTCSqVZJJY")
val Assertion_cborSchemaId = ByteString(-75, -24, 18, -40, -18, 55, -112, 9, -28, -56, -102, -84, -80, 27, 123, 65, 3, 45, -53, 88, 78, -118, 53, -119, -101, 20, -62, 74, -91, 89, 36, -106)

fun Assertion.Companion.fromCbor(data: ByteArray): Assertion {
    return Assertion.fromDataItem(Cbor.decode(data))
}

val Assertion.Companion.cborSchemaId: ByteString
    get() = Assertion_cborSchemaId

fun Assertion.toDataItem(): DataItem {
    return when (this) {
        is AssertionBindingKeys -> (this as AssertionBindingKeys).toDataItem()
        is AssertionGenericCbor -> (this as AssertionGenericCbor).toDataItem()
        is AssertionNonce -> (this as AssertionNonce).toDataItem()
        is AssertionPoPKey -> (this as AssertionPoPKey).toDataItem()
        is AssertionRpcAuth -> (this as AssertionRpcAuth).toDataItem()
    }
}

fun Assertion.Companion.fromDataItem(dataItem: DataItem): Assertion {
    val type = dataItem["type"].asTstr
    return when (type) {
        "BindingKeys" -> AssertionBindingKeys_fromDataItem(dataItem)
        "GenericCbor" -> AssertionGenericCbor_fromDataItem(dataItem)
        "Nonce" -> AssertionNonce_fromDataItem(dataItem)
        "PoPKey" -> AssertionPoPKey_fromDataItem(dataItem)
        "RpcAuth" -> AssertionRpcAuth_fromDataItem(dataItem)
        else -> throw IllegalArgumentException("wrong type: $type")
    }
}
